export const GET_ME = '/auth/me'
